<template>
  <div ref="columnSetTooltip">
    <button
      class="tw-group tw-mx-4 tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-primary-grey-100 tw-pl-4"
      :disabled="disabled"
      @click="onColumnsButtonClick"
      :data-test-id="`${dataTestId}-columns-settings-btn`"
    >
      <cb-icon-customise-display :class="iconClass" />
      <div
        v-if="!isNewLabelVisited"
        class="tw--mt-2 tw-self-start"
        :data-test-id="`${dataTestId}-columns-settings-pill-new`"
      >
        <cl-pill :variant="'success'" :uppercase="false">
          <div class="tw--ml-1 tw--mr-1">{{ $t("new") }}</div>
        </cl-pill>
      </div>
    </button>
    <div
      v-if="isColumnSetTooltipOpen"
      id="set-rows-wrapper"
      class="tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-flex-col tw-rounded-md tw-border tw-border-primary-grey-100 tw-bg-white tw-shadow-md tw-transition-opacity"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import { trackEvent } from "@/utils/track-event";
import { useCookies } from "@vueuse/integrations/useCookies";
import { DATA_TABLE_COOKIE } from "@/constants";

export type Props = {
  disabled?: boolean;
  trackingEventCategoryBaseName: string;
  dataTestId: string;
};

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const isColumnSetTooltipOpen = ref(false);

const COOKIE_KEY = `${DATA_TABLE_COOKIE.MSP_CUSTOMERS_LIST}-new-columns-settings-visited`;
const cookies = useCookies();
const isNewLabelVisited = computed(() => cookies.get(COOKIE_KEY));
const setCookie = () => cookies.set(COOKIE_KEY, true);

const onColumnsButtonClick = (): void => {
  isColumnSetTooltipOpen.value = !isColumnSetTooltipOpen.value;

  setCookie();

  trackEvent({
    category: `${props.trackingEventCategoryBaseName} columns`,
    action: "Columns button clicked",
    name: "",
  });
};
const iconClass = computed(() => {
  if (props.disabled) {
    return "tw-stroke-primary-grey-200 tw-cursor-not-allowed";
  }
  if (isColumnSetTooltipOpen.value) {
    return "tw-stroke-primary-grey-700";
  }
  return "tw-stroke-primary-grey-700 tw-transition-colors group-hover:tw-stroke-primary-grey-700";
});

const columnSetTooltip = ref(null);
onClickOutside(columnSetTooltip, () => (isColumnSetTooltipOpen.value = false));
</script>
